import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { IconButton } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { createhostellogin, getGCB, getHostelCategory } from "../api/Users";
import "sweetalert2/dist/sweetalert2.min.css";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import "react-responsive-modal/styles.css";
import axios from "../api/constant";

const AssignHeadmaster = ({ role, userData }) => {
  const { t } = useTranslation();
  const [AllSchoolNames, setAllSchoolNames] = useState([]);
  const [Alldistricts, setAllDistricts] = useState([]);
  const [Allblocks, setAllBlocks] = useState([]);
  const [Allvillages, setAllVillages] = useState([]);
  const [AllGPs, setAllGPs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [markRequired, setMarkRequired] = useState(true);
  const [Hostelname, setHostelname] = useState("");
  const [Emailid, setEmailid] = useState("");
  const [SchoolName, setSchoolName] = useState("");
  const [Password, setPassword] = useState("");
  const [ConfirmPassword, setConfirmPassword] = useState("");
  const [Address, setAddress] = useState("");
  const [District, setDistrict] = useState("");
  const [Village, setVillage] = useState("");
  const [schoolId, setSchoolId] = useState("");
  //   const [Role, setRole] = useState("");
  const [UDISE, setUDISE] = useState("");
  const [Block, setBlock] = useState("");
  const [GP, setGP] = useState("");
  const [number, setNumber] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
  const [passwordMismatchError, setPasswordMismatchError] = useState("");
  //   const [gcb, setGcb] = useState([]);
  const [category, setCategory] = useState("");
  //   const [categories, setCategories] = useState([]);
  const [gbcType, setGcbType] = useState("");
  const [headmasterName, setHeadMasterName] = useState("");
  const [schoolType, setSchoolType] = useState("");

  const {
    register,
    reset,
    formState: { errors },
  } = useForm();
  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  useEffect(() => {
    // Call API to fetch districts when the component mounts
    axios
      .get("/get_all_districts")
      .then((response) => {
        console.log(response);
        if (response.data.status == "success") {
          setAllDistricts(response.data.data);
        } else {
          setAllDistricts([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching districts:", error);
      });
  }, []);

  useEffect(() => {
    if (District) {
      // Call API to fetch blocks based on selected district
      axios
        .get(`/get_block_from_district?district_code=${District}`)
        .then((response) => {
          if (response.data.status == "success") {
            setAllBlocks(response.data.data.new_asset_query);
          } else {
            setAllBlocks([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching blocks:", error);
        });
    }
  }, [District]);

  useEffect(() => {
    if (District && Block) {
      // Call API to fetch villages based on selected block
      axios
        .get(
          `/get_gp_from_block_and_district?district_code=${District}&block_code=${Block}`
        )
        .then((response) => {
          if (response.data.status == "success") {
            setAllGPs(response.data.data.new_asset_query);
          } else {
            setAllGPs([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching villages:", error);
        });
    }
  }, [District, Block]);

  useEffect(() => {
    if (District && Block && GP) {
      // Call API to fetch villages based on selected block
      axios
        .get(
          `/get_village_from_gp_block_and_district?district_code=${District}&block_code=${Block}&gp_code=${GP}`
        )
        .then((response) => {
          if (response.data.status == "success") {
            setAllVillages(response.data.data.new_asset_query);
          } else {
            setAllVillages([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching villages:", error);
        });
    }
  }, [District, Block, GP]);

  useEffect(() => {
    if (Village) {
      // Call API to fetch villages based on selected block
      axios
        .get(`/get_school_name_gmid?gm_id=${Village}`)
        .then((response) => {
          if (response.data.status == "success") {
            setAllSchoolNames(response.data.data.new_asset_query);
          } else {
            setAllSchoolNames([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching villages:", error);
        });
    }
  }, [Village]);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible(!confirmPasswordVisible);
  };

  const handleSchoolName = (event) => {
    const selectedSchool = JSON.parse(event.target.value);
    setSchoolId(selectedSchool.school_id);
    setUDISE(selectedSchool.code);
  };

  const handleEmailChange = (event) => {
    setEmailid(event.target.value);
    validateEmail(event.target.value);
  };

  const handleContactNoChange = (event) => {
    setNumber(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    if (ConfirmPassword && event.target.value !== ConfirmPassword) {
      setPasswordMismatchError("Passwords do not match");
    } else {
      setPasswordMismatchError("");
    }
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
    if (Password && event.target.value !== Password) {
      setPasswordMismatchError("Passwords do not match");
    } else {
      setPasswordMismatchError("");
    }
  };

  const handleDistrictChange = (event) => {
    setDistrict(event.target.value);
    setBlock(""); // Reset block and village when district changes
    setVillage("");
    setGP("");
    setAllBlocks([]);
    setAllVillages([]);
    setAllGPs([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setSchoolId("");
  };

  const handleBlockChange = (event) => {
    setBlock(event.target.value);
    setVillage("");
    setGP("");
    setAllVillages([]);
    setAllGPs([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setSchoolId("");
  };
  const handleGPChange = (event) => {
    setGP(event.target.value);
    setVillage("");
    setAllVillages([]);
    setAllSchoolNames([]);
    setSchoolName("");
    setSchoolId("");
  };
  const handleVillageChange = (event) => {
    setVillage(event.target.value);
    setAllSchoolNames([]);
    setSchoolName("");
    setSchoolId("");
  };
  const validateEmail = (email) => {
    if (
      !(
        /^[a-zA-Z0-9._%+-]+@gmail.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@outlook.com$/.test(email) ||
        /^[a-zA-Z0-9._%+-]+@yahoo.com$/.test(email)
      )
    ) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const handleNameChange = (e) => {
    setHeadMasterName(e.target.value);
  };

  const handleSubmitForm = async (event, data) => {
    setIsLoading(true)
    event.preventDefault();
    if (emailError) {      
      setIsLoading(false)
      toast.error("Please provide a valid email address.");
      return;
    }
    if (Password !== ConfirmPassword) {
      setIsLoading(false)
      toast.error("Passwords do not match");
      return;
    }

    const Postdata = {
      role_id: role,
      gm_id: GP,
      name: headmasterName,
      email: Emailid,
      mobile_no: number,
      password: Password,
      district_code: District,
      block_code: Block,
      gp_code: GP,
      village_code: Village,
      UDISE_code: UDISE,
      school_name: schoolId,
      school_type: schoolType,
      category: category,
      gbc_id: gbcType,
    };

    createhostellogin(Postdata)
      .then((response) => {
        if (response.status == "success") {
          setIsLoading(false)
          toast.success(response.message);
          reset();
          setDistrict("");
          setBlock("");
          setVillage("");
          setGP("");
          setSchoolType("");
          setCategory("");
          setSchoolName("");
          setSchoolId("");
          setGcbType("");
          setUDISE("");
          setHeadMasterName("");
          setAllBlocks([]);
          setAllVillages([]);
          setAllGPs([]);
          setNumber("");
          setAllSchoolNames([]);
          setConfirmPassword("");
          setEmailid("");
          // window.location.reload();
        }
      })
      .catch((error) => {
        console.error("Error rejecting requirement:", error);
        toast.error(
          error.response?.data?.message || "Failed to reject requirement"
        );
      });
  };

  const toggleClearButton = () => {
    setDistrict("");
    setBlock("");
    setVillage("");
    setGP("");
    setSchoolType("");
    setCategory("");
    setSchoolName("");
    setSchoolId("");
    setGcbType("");
    setUDISE("");
    setHeadMasterName("");
    setAllBlocks([]);
    setAllVillages([]);
    setAllGPs([]);
    setNumber("");
    setAllSchoolNames([]);
    setPassword("");
    setConfirmPassword("");
    setEmailid("");
  };
  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="px-2 px-md-4">
        <form
          id="myform1"
          onSubmit={(e, data) => handleSubmitForm(e, data)}
          style={{ marginTop: "12px" }}
        >
          <h5 className="my-4">{t("Assign Headmaster")}</h5>

          <div className="row">
            {/*District */}
            <div className="col-md-4">
              <label className="form-label">
                {t("District")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="district" // value={AssetsType}
                className="common-input form-select"
                onChange={handleDistrictChange}
                required
              >
                <option value="">{t("Select District")}</option>
                {/* Map assetOptions to generate option elements */}
                {Alldistricts &&
                  Alldistricts.map((row, index) => (
                    <option key={index} value={row.district_code}>
                      {" "}
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* Block */}
            <div className="col-md-4">
              <label className="form-label">
                {t("Block")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="GP" // value={AssetsType}
                className="common-input form-select"
                onChange={handleBlockChange}
                required
              >
                <option value="">{t("Select Block")}</option>
                {/* Map assetOptions to generate option elements */}
                {Allblocks &&
                  Allblocks.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* GP */}
            <div className="col-md-4">
              <label className="form-label">
                {t("GP")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="GP" // value={AssetsType}
                className="common-input form-select"
                onChange={handleGPChange}
                required
              >
                <option value="">{t("Select GP")}</option>
                {/* Map assetOptions to generate option elements */}
                {AllGPs &&
                  AllGPs.map((row, index) => (
                    <option key={index} value={row.code}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="row" style={{ marginTop: "12px" }}>
            {/* Village Name */}
            <div className="col-md-4">
              <label className="form-label">
                {t("Village Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="Village" // value={AssetsType}
                className="common-input form-select"
                onChange={handleVillageChange}
                required
              >
                <option value="">{t("Select Village Name")}</option>
                {/* Map assetOptions to generate option elements */}
                {Allvillages &&
                  Allvillages.map((row, index) => (
                    <option key={index} value={row.gm_id}>
                      {row.village_name}
                    </option>
                  ))}
              </select>
            </div>
            {/* School Name */}
            <div className="col-md-4">
              <label className="form-label">
                {t("School Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <select
                name="SchoolName" // value={AssetsType}
                className="common-input form-select"
                onChange={handleSchoolName}
                required
              >
                <option value="">{t("Select School Name")}</option>
                {/* Map assetOptions to generate option elements */}
                {AllSchoolNames &&
                  AllSchoolNames.map((row, index) => (
                    <option key={index} value={JSON.stringify(row)}>
                      {row.name}
                    </option>
                  ))}
              </select>
            </div>
            {/* UDISE No. */}
            <div className="col-md-4">
              <label className="form-label">{t("UDISE")}</label>
              <input
                type="text"
                name="UDISE"
                disabled
                className="form-control"
                value={UDISE}
              />
            </div>
          </div>

          <div className="row" style={{ marginTop: "12px" }}>
            <div className="col-md-4">
              <label className="form-label">
                {t("Headmaster Name")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                name="Headmaster_name"
                className="form-control"
                value={headmasterName}
                onChange={handleNameChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Headmaster Mobile Number")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="number"
                pattern="[0-9]*"
                max={9999999999}
                min={999999999}
                name="mobile_no"
                className="form-control"
                onChange={handleContactNoChange}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Ashram Email ID")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={Emailid}
                onChange={handleEmailChange}
                required
              />
              {emailError && <span className="text-danger">{emailError}</span>}
            </div>
          </div>
          <div
            className="row"
            style={{ marginTop: emailError ? "0px" : "12px" }}
          >
            <div className="col-md-4">
              <label className="form-label">
                {t("New Password")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <input
                  type={passwordVisible ? "text" : "password"}
                  name="password"
                  className={`form-control ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  {...register("password", {
                    required: t("Password is required"),
                    pattern: {
                      value: strongPasswordRegex,
                      message: t(
                        "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
                      ),
                    },
                  })}
                  onChange={handlePasswordChange}
                />
                <span
                  className="input-group-text"
                  onClick={togglePasswordVisibility}
                >
                  <IconButton size="small">
                    {passwordVisible ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </span>
              </div>
              {errors.password && (
                <span className="error-text">{errors.password?.message}</span>
              )}
            </div>
            <div className="col-md-4">
              <label className="form-label">
                {t("Confirm Password")}{" "}
                {markRequired && <span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <input
                  type={confirmPasswordVisible ? "text" : "password"}
                  name="confirm_password"
                  className={`form-control ${
                    passwordMismatchError ? "is-invalid" : ""
                  }`}
                  value={ConfirmPassword}
                  onChange={handleConfirmPasswordChange}
                  required
                />
                <span
                  className="input-group-text"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  <IconButton size="small">
                    {confirmPasswordVisible ? (
                      <Visibility />
                    ) : (
                      <VisibilityOff />
                    )}
                  </IconButton>
                </span>
              </div>
              {passwordMismatchError && (
                <span className="error-text">{passwordMismatchError}</span>
              )}
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary me-2">
                {t("Submit")}
              </button>
              <button
                onClick={toggleClearButton}
                type="button"
                className="btn btn-secondary"
              >
                {t("Clear")}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AssignHeadmaster;
